import { Glance } from "../components/Glance";
import { Reveal } from "../components/Reveal";
import { Soon } from "../components/Soon";
import { DETAILS_COMING_SOON, comingSoon, details } from "../content/wedding";

export function Details() {
  return (
    <section class="section" id="details">
      <div class="shell">
        <Reveal class="section-head">
          <span class="eyebrow">The fine details</span>
          <h2>On the Day</h2>
        </Reveal>

        {DETAILS_COMING_SOON ? (
          <Soon>{comingSoon.note.details}</Soon>
        ) : (
          <>
            <Reveal delay={60}>
              <Glance />
            </Reveal>

            <div class="faq">
              {details.map((item, i) => (
                <Reveal key={item.q} delay={i * 60}>
                  <details class="faq__item">
                    <summary class="faq__q">
                      {item.q}
                      <span class="faq__sign" aria-hidden="true" />
                    </summary>
                    <p class="faq__a">{item.a}</p>
                  </details>
                </Reveal>
              ))}
            </div>
          </>
        )}
      </div>
    </section>
  );
}
